module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }